export enum AccountActions {
  LOGIN = "login",
  LOGOUT= "logout",
  FETCH_ACCOUNTS="fetch accounts"
}